import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=4ac8b1f9&scoped=true"
import script from "./AdminHeader.vue?vue&type=script&lang=js"
export * from "./AdminHeader.vue?vue&type=script&lang=js"
import style0 from "./AdminHeader.vue?vue&type=style&index=0&id=4ac8b1f9&lang=less&scoped=true"
import style1 from "./AdminHeader.vue?vue&type=style&index=1&id=4ac8b1f9&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8b1f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac8b1f9')) {
      api.createRecord('4ac8b1f9', component.options)
    } else {
      api.reload('4ac8b1f9', component.options)
    }
    module.hot.accept("./AdminHeader.vue?vue&type=template&id=4ac8b1f9&scoped=true", function () {
      api.rerender('4ac8b1f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/header/AdminHeader.vue"
export default component.exports